export const BASIC_YELLOW = "#F8B500";
export const BASIC_BROWN = "#502700";
export const BASIC_ORANGE = "#E66231";
export const BASIC_GRAY = "#999999";
export const BASIC_DARK_GRAY = "#333333";
export const BASIC_LIGHT_GRAY = "#F4F4F4";
export const BASIC_GRAY_BACKGROUND = "#EFEFEF";
export const BASIC_DISABLED = "#CACACA";
export const BASIC_LINE = "#DBDBDB";
export const BASIC_WHITE = "#FFFFFF";
export const BASIC_BLACK = "#000000";
export const BASIC_LIGHT_BLUE = "#79BCCC";
